import React from 'react';
import { Navigate } from 'react-router';
import Loading from '@/components/loading.component';
import { useShowAuthenticatedView } from '@/auth/hooks/use-show-authenticated-view';
import { StyledLoadingContainer } from './auth-guard.styles';
export const AuthGuard = (props) => {
    const { children, fallbackPath, pathType } = props;
    const { showAuthenticatedView, isLoading: isShowAuthViewLoading } = useShowAuthenticatedView();
    const isLoading = isShowAuthViewLoading;
    if (isLoading) {
        return (<React.Fragment>
        <StyledLoadingContainer>
          <Loading isLoading={true} label="Loading"/>
        </StyledLoadingContainer>
      </React.Fragment>);
    }
    const fallbackCondition = (pathType === 'protected' && !showAuthenticatedView)
        || (pathType === 'public' && showAuthenticatedView);
    if (fallbackCondition) {
        return <Navigate to={fallbackPath}/>;
    }
    return <React.Fragment>{children}</React.Fragment>;
};
export default AuthGuard;
